import { HomePageComponentForAdmin } from "@/pages-components/admin/home/home";
import { useMediaQuery } from "@mui/material";
import { withThemeOverride, useThemeComponent } from "@/contexts/theme";
import type { NextPageWithLayout } from "@/layouts/page-layout";


function Home() {
  const isMobileScreen = useMediaQuery("(max-width:768px)");

  // Get theme-aware version of HomePageComponentForAdmin
  const ThemedHomePageComponent = useThemeComponent(
    "HomePageComponent",
    HomePageComponentForAdmin
  );

  return (
    <ThemedHomePageComponent isMobileScreen={isMobileScreen} />
  );
}

// Wrap the entire page with theme override support
const Page = withThemeOverride("HomePage", Home) as NextPageWithLayout;
Page.pageLayout = { type: "customer", props: {
    className: "custom-scrollbar",
    backgroundColor: "var(--theme-bg-body, #f6f6f6)",
  } };
export default Page;
